<template>
    <div class="filter_wrapper text_left">
        <v-select
            v-model="selectedYear"
            :options="years"
            label="text"
            :reduce="item => item.value"
            :clearable="false"
            :searchable="false"
            dir="rtl"
            class="selectric-wrapper"
        >
            <template #open-indicator>
                <b class="button" />
            </template>
        </v-select>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import { mapActions } from 'vuex';

export default {
    components: {
        vSelect
    },

    data() {
        const allYears = {
            text: 'סנן לפי',
            value: null
        };

        return {
            selectedYear: null,
            years: [allYears]
        };
    },

    async fetch() {
        try {
            const years = await this.getYears();

            this.years.push(
                ...years.map(({ date }) => ({ text: date, value: date }))
            );
        } catch (error) {
            console.error(error);

            this.$toasted.global.error();
        }
    },

    watch: {
        selectedYear(value) {
            this.$emit('selected', value);
        }
    },

    methods: {
        ...mapActions({
            getYears: 'transparency/getYears'
        })
    }
};
</script>
